import { Injectable } from '@angular/core';
import { ResourceAction, ResourceParams, ResourceRequestMethod, IResourceMethod } from '@ngx-resource/core';
import { RestClient } from './rest.client';
import { environment } from '../../environments/environment';

interface User {
    data: any;
}

@Injectable()
@ResourceParams({
    url: `${environment.url.api}`,
    pathPrefix: '/api/user'
})
export class UserService extends RestClient {
    @ResourceAction({
        path: '/myinfo'
    })
    getUserInfo: IResourceMethod<{}, User>;

    @ResourceAction({
        path: '/save',
        method: ResourceRequestMethod.Put
    })
    saveUser: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/forgotpassword',
        method: ResourceRequestMethod.Post,
        noAuth: true
    })
    requestPassword: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/continueWithSSO',
        method: ResourceRequestMethod.Get,
        noAuth: true
    })
    continueWithSSO: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/forgotpassword/valid/{:token}',
        noAuth: true
    })
    getIsValid: IResourceMethod<{ token: any }, any>;

    @ResourceAction({
        path: '/resetpassword/valid/{:token}',
        noAuth: true
    })
    getIsValidReset: IResourceMethod<{ token: any }, any>;

    @ResourceAction({
        path: '/forgotpassword/reset',
        method: ResourceRequestMethod.Post,
        noAuth: true
    })
    resetPassword: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/resetpassword/reset',
        method: ResourceRequestMethod.Post,
        noAuth: true
    })
    resetPasswordReset: IResourceMethod<any, any>;

    @ResourceAction({
        path: '/changepassword',
        method: ResourceRequestMethod.Post
    })
    changePassword: IResourceMethod<any, any>;
}
